<template>
    <v-container fluid class="d-flex flex-wrap justify-start">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-sheet class="pa-1">
            <v-card @click="fuDescargarFicha('Khipu/Secretaria%20Academica/FichaDeSeguimiento', 'FichaDeSeguimiento')" max-width="380" outlined color="blue-grey lighten-3" >
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-card-title style="color:blue-grey" class="pa-0">
                            Ficha de Seguimiento
                        </v-card-title>
                    </v-list-item-content>
                    <v-list-item-avatar color="blue-grey" size="80">
                        <v-icon size="60">poll</v-icon>
                    </v-list-item-avatar>
                </v-list-item>
            </v-card>
        </v-sheet>
        <v-sheet class="pa-1">
            <v-card @click="fuDescargarFicha('Khipu/Secretaria%20Academica/Ficha%20de%20Curso%20Khipu', 'FichaDeCursoKhipu')" max-width="380" outlined color="blue-grey lighten-3" >
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-card-title style="color:blue-grey" class="pa-0">
                            Ficha de Curso Khipu
                        </v-card-title>
                    </v-list-item-content>
                    <v-list-item-avatar color="blue-grey" size="80">
                        <v-icon size="60">poll</v-icon>
                    </v-list-item-avatar>
                </v-list-item>
            </v-card>
        </v-sheet>
    </v-container>
</template>
<script>
import moment from 'moment';
import axios from 'axios';

export default {
    name: 'ReporteAlumnoByIdAlumno',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        }
    },
    data: () => ({
        dLoading: false,
    }),
    methods: {
        async fuGetReporte(params, p_url){
            let url = 'https://tamboreportserver.khipu.edu.pe/ReportServer/?/' + p_url + '&rs:Command=Render&rs:Format=PDF';
            Object.keys(params).forEach(key => {
                url += '&' + key + '=' + params[key];
            });

            const response = await axios.get(url, {
                responseType: 'arraybuffer',
                headers: {
                    'Authorization': 'Basic ' + Buffer.from('Khipu\\Administrador:@khipu@ayllu40').toString('base64'),
                    'Accept': 'application/pdf'
                }
            })
            return response.data
        },
        async fuDescargarFicha(p_url, p_name){
            this.dLoading = true;
            try {
                const params = {
                    IdAlumno: this.pIdAlumno
                }
                const data = await this.fuGetReporte(params, p_url);

                const blob = new Blob([data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = p_name + '_' + moment().format("YYYYMMDD HH:mm:ss") + '.pdf'; // Nombre del archivo a guardar
                link.click(); // Simula el clic para descargar el archivo
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false
            }
        },
    }
}
</script>
